import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import fbIcon from "../images/homepage/wired-outline-2540-logo-facebook-hover-pinch.png";
import instaIcon from "../images/homepage/wired-outline-2542-logo-instagram-hover-pinch.png";
import logo from "../images/2-removebg-preview.png";
import "./BookingFooter.css";

const BookingFooter = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (e, id) => {
    e.preventDefault();
    // If on booking page, scroll to element; otherwise navigate to booking page with hash
    if (location.pathname === "/booking") {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate(`/booking#${id}`);
    }
  };

  return (
    <footer className="booking-footer">
      <div className="booking-footer-content">
        {/* Brand Column */}
        <div className="footer-col brand-col">
          <img src={logo} alt="Calyx Logo" className="footer-logo-img" style={{ height: "100px", marginBottom: "20px" }} />
          <p className="footer-desc">
            Decoding the architecture of volume to elevate global hairstyling standards. Joined by International Master Artist Konstantin Borchininov.
          </p>
        </div>

        {/* Navigation Column */}
        <div className="footer-col">
          <h4 className="footer-heading">NAVIGATION</h4>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><a href="#tickets" onClick={(e) => handleScroll(e, "tickets")}>Schedule</a></li>
            <li><a href="#master-artist" onClick={(e) => handleScroll(e, "master-artist")}>About Kostya</a></li>
            <li><a href="#faq" onClick={(e) => handleScroll(e, "faq")}>FAQ</a></li>
            <li><a href="#contact" onClick={(e) => handleScroll(e, "contact")}>Contact Us</a></li>
          </ul>
        </div>

        {/* Inquiries Column */}
        <div className="footer-col">
          <h4 className="footer-heading">INQUIRIES</h4>
          <div className="inquiry-item">
            <span className="inquiry-label">EMAIL</span>
            <a href="mailto:Info.prolongprofessional@gmail.com">Info.prolongprofessional@gmail.com</a>
          </div>
          <div className="inquiry-item">
            <span className="inquiry-label">PHONE</span>
            <a href="tel:+918780933566">+91 87809-33566</a>
          </div>
          <div className="inquiry-item">
            <span className="inquiry-label">ADDRESS</span>
            <p>A 1313 Titanium Business Park,<br />Near Makarba Under Bridge,<br />Ahmedabad 380051</p>
          </div>
        </div>

        {/* Follow Column */}
        <div className="footer-col follow-col">
          <h4 className="footer-heading">Follow Us</h4>
          <div className="social-links">
            <a href="https://www.facebook.com/CalyxProfessionals" target="_blank" rel="noreferrer" className="social-icon">
              <img src={fbIcon} alt="Facebook" className="social-img" />
            </a>
            <a href="https://www.instagram.com/calyxprofessional.india/
 " target="_blank" rel="noreferrer" className="social-icon">
              <img src={instaIcon} alt="Instagram" className="social-img" />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 CALYX Hair Care. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default BookingFooter;
